export interface CastProject {
  id: string
  name: string
  description: string
  scriptsDir: string
  promptLabel: string
  videoIdMap: Record<string, string>
}

export interface ReferenceImage {
  mimeType: string
  data: string
}

export interface Shot {
  videoId: string
  videoNum: string
  shotNumber: number
  shotId: string
  label: string
  prompt: string
  aspectRatio: string
  durationHint: number
  group?: string
  sequence?: number
}

export type TransitionType =
  | 'dissolve'
  | 'fade'
  | 'fadewhite'
  | 'wipeleft'
  | 'wiperight'
  | 'slideleft'
  | 'slideright'
  | 'circleopen'
  | 'pixelize'

export interface TransitionConfig {
  type: TransitionType
  duration: number  // seconds, 0.2–2.0
}

export const TRANSITION_LABELS: Record<TransitionType, string> = {
  dissolve:    'Dissolve',
  fade:        'Fade to Black',
  fadewhite:   'Fade to White',
  wipeleft:    'Wipe Left',
  wiperight:   'Wipe Right',
  slideleft:   'Slide Left',
  slideright:  'Slide Right',
  circleopen:  'Circle Open',
  pixelize:    'Pixelize',
}

export interface MergeJobStatus {
  state: 'idle' | 'loading' | 'merging' | 'uploading' | 'done' | 'failed'
  progress: number     // 0–100, live during 'merging'
  log: string
  error: string | null
  file: string | null  // proxy URL when done
}

export interface SequenceJobStatus {
  state: 'idle' | 'generating' | 'extending' | 'done' | 'failed'
  currentStep: number
  totalSteps: number
  startedAt?: number
  serverNow?: number
  error: string | null
  file: string | null
  segments: Array<{ id: string; label: string; startSec: number; endSec: number }>
}

export interface JobStatus {
  state: 'idle' | 'generating' | 'done' | 'failed'
  elapsed: number
  error: string | null
  file: string | null
  logs: Array<{ time: number; msg: string }>
}

